import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import api_views = api_configuration.libraries.gui_definition_lib.types.views.alan_api;
import { entityBuilderOf } from "../navigation/IdPathBuilder";
import { createIdPathBuilderFromNode } from "../navigation/createIdPathFromNode";
import ImplementationVisitorContext from "./ImplementationVisitorContext";
import * as mapToIdPathBuilder from "../state/mapToIdPathBuilder";
import { ensure } from "../validation";
import openViewOnNode from "../front/openViewOnNode";
import { iReference } from "../state/Reference";
import * as Rule from "../state/Rule";
import { getWindowInstance } from "../widgets/dom/Window";
import * as step from "../state/step";
import { createExpressionBuilder } from "../../../../../stream";

export function openViewContext(
	view: api_views.Cview__type__gui_widget_configuration_attribute,
	implementation_context: ImplementationVisitorContext
): void {
	const view_context = view.properties.view_context;

	const view_def = view.properties.view.ref;
	const window = view.properties.render.switch({
		"in window": ($) => $.properties.window.ref,
	});

	switch (view_context.properties.has_steps.state.name) {
		case "no":
			openViewOnNode(implementation_context.clientStateAsNode, view_def, window);
			break;
		case "yes": {
			const $ = view_context.properties.has_steps.state.node;
			switch ($.properties.type.state.name) {
				case "query entry": {
					//TODO do not use instanceof
					if (implementation_context.current_binding_context instanceof api_cs.Cnode) {
						openViewOnNode(implementation_context.current_binding_context, view_def, window);
					} else if (implementation_context.current_binding_context instanceof api_cs.Centries__yes__has_result) {
						const binding_context = implementation_context.current_binding_context;
						switch (binding_context.properties.entry_status.properties.initialized.state.name) {
							case "no": {
								const id_path = entityBuilderOf(
									mapToIdPathBuilder.fromClientState(
										binding_context.properties.entry_status.properties.initialized.state.node.properties.referenced_node
									)
								);
								openViewOnNode(id_path, view_def, window);
								break;
							}
							case "yes": {
								const initialized = binding_context.properties.entry_status.properties.initialized.state.node;
								const node = initialized.properties.referenced_node.output.result_node();
								openViewOnNode(node, view_def, window);
								break;
							}
							case "unknown":
								throw new Error("");
							default:
								unexpectedState(binding_context.properties.entry_status.properties.initialized.state);
						}
					} else {
						throw new Error("");
					}
					break;
				}
				case "entity": {
					const binding_context = ensure(implementation_context.current_binding_context, api_cs.Cnode);
					const id_path = createIdPathBuilderFromNode(binding_context.input.entity().input.node());
					openViewOnNode(id_path, view_def, window);
					break;
				}
				case "parent": {
					const parent__type = $.properties.type.state.node;
					const local_parent_node = walk_view_context_parent_path_over_node(
						parent__type.properties.path,
						implementation_context.clientStateAsNode
					);
					openViewOnNode(local_parent_node, view_def, window);
					break;
				}
				case "reference": {
					const binding_context = ensure(implementation_context.current_binding_context, api_cs.Ctext__type__property);
					const reference = binding_context.properties.navigable.cast("yes");
					const stream = createExpressionBuilder(iReference(reference).referencedNode).pipe(
						step.sync((node, destructor) => {
							const open_view = openViewOnNode(node.input.entity().input.node(), view_def, window);
							destructor.onDestroy(() => getWindowInstance(window.key).close_view(open_view));
							open_view.onDestroy(() => stream.unsubscribe(subscription));
						})
					)();
					const subscription = stream.subscribe({ update: () => undefined });
					break;
				}
				case "state rule": {
					const rule = ensure(implementation_context.current_binding_context, api_cs.Crules);
					const stream = createExpressionBuilder(Rule.node(rule)).pipe(
						step.sync((node, destructor) => {
							const open_view = openViewOnNode(node.input.entity().input.node(), view_def, window);
							destructor.onDestroy(() => getWindowInstance(window.key).close_view(open_view));
							open_view.onDestroy(() => stream.unsubscribe(subscription));
						})
					)();
					const subscription = stream.subscribe({ update: () => undefined });
					break;
				}
				default:
					unexpectedState($.properties.type.state);
			}
			break;
		}
		default:
			unexpectedState(view_context.properties.has_steps.state);
	}
}

function walk_view_context_parent_path_over_node(
	path: api_views.Cview_context_parent_path,
	node: api_cs.Cnode
): api_cs.Cnode {
	const intermediate_result = path.properties.type.switch({
		"collection parent": function () {
			return node.input.position().cast("entity").cast("entry").parent.parent.parent.parent;
		},
		"group parent": function () {
			return node.input.position().cast("group").parent.parent.parent;
		},
		"state parent": function () {
			return node.input.position().cast("state").parent.parent.parent.parent;
		},
	});

	return path.properties.has_tail.switch({
		no: intermediate_result,
		yes: function ($) {
			return walk_view_context_parent_path_over_node($.properties.tail, intermediate_result);
		},
	});
}
